'use strict';

exports.BROWSER = 'BROWSER';
exports.SERVER = 'SERVER';